import { __extends } from "tslib";
/*
* Properties.ts
* @author Abhilash Panwar (abpanwar) Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* File containing Properties plugin to collect common properties.
*/
import { BaseTelemetryPlugin, getLocation, Utils, CoreUtils } from '@microsoft/1ds-core-js';
import { _Extensions, _SignalExtKeys, _SharedKeys, _SDKVersion, _UserExtKeys, _MSEI, _ViewEventName, _ActionEventName } from './Constants';
var mseiCookieExpiryDays = 365;
/**
 * This class adds a telemetry plugin to populate autocollected properties.
 */
var Properties = /** @class */ (function (_super) {
    __extends(Properties, _super);
    function Properties() {
        var _this = _super.call(this) || this;
        _this._user = {};
        _this._props = {};
        //Get time zone
        var timeZone = new Date().getTimezoneOffset();
        var minutes = timeZone % 60;
        var hours = (timeZone - minutes) / 60;
        var timeZonePrefix = '+';
        if (hours > 0) {
            timeZonePrefix = '-';
        }
        hours = Math.abs(hours);
        minutes = Math.abs(minutes);
        _this._timeZone = timeZonePrefix + (hours < 10 ? '0' + hours : hours.toString()) + ':' + (minutes < 10 ? '0' + minutes : minutes.toString());
        //Get domain
        var windowLocation = getLocation();
        if (windowLocation) {
            var domain = windowLocation.hostname;
            _this.origin = windowLocation.origin;
            if (domain) {
                _this._domain = windowLocation.protocol === 'file:' ? 'local' : domain;
            }
        }
        return _this;
    }
    Properties.prototype.setup = function (SessionManager) {
        this._msei = Utils.getCookie(_MSEI);
        if (!this._msei) {
            this._msei = Utils.createGuid();
            Utils.setCookie(_MSEI, this._msei, mseiCookieExpiryDays);
            this._mseiCreated = true;
        }
        this._sessionManager = SessionManager;
    };
    /**
     * Process the current telemetry item.
     * @param event event to process
     * @param itemCtx context information for the core telemetry library
     */
    Properties.prototype.processTelemetry = function (event, itemCtx) {
        event.data[_Extensions._SignalExt][_SignalExtKeys._ExtKey][_SharedKeys._TimeZone] = this._timeZone;
        event.data[_Extensions._SignalExt][_SignalExtKeys._ExtKey][_SharedKeys._Source] = 'Web';
        event.data[_Extensions._SignalExt][_SignalExtKeys._Sdk] = {};
        event.data[_Extensions._SignalExt][_SignalExtKeys._Sdk][_SharedKeys._Version] = _SDKVersion;
        event.data[_Extensions._SignalExt][_SignalExtKeys._Host] = {};
        event.data[_Extensions._SignalExt][_SignalExtKeys._Host][_SharedKeys._Domain] = this._domain;
        //Add user fields
        event.data[_Extensions._SignalExt][_SignalExtKeys._User] = {};
        event.data[_Extensions._SignalExt][_SignalExtKeys._User][_UserExtKeys._LocalId] = this._user.localId || this._msei;
        event.data[_Extensions._SignalExt][_SignalExtKeys._User][_UserExtKeys._AuthId] = this._user.authId;
        event.data[_Extensions._SignalExt][_SignalExtKeys._User][_UserExtKeys._AuthType] = this._user.authType;
        event.data[_Extensions._SignalExt][_SignalExtKeys._User][_UserExtKeys._Email] = this._user.email;
        event.data[_Extensions._SignalExt][_SignalExtKeys._User][_SharedKeys._NameKey] = this._user.name;
        //Pass event to session manager to process and add required session fields.
        this._sessionManager._processEvent(event, this._mseiCreated, event.name === _ViewEventName || event.name === _ActionEventName);
        //Add common custom properties
        this._addPropsIfNotAlreadyAdded(event.data);
        //Delete empty properties
        this._removeEmptyKeys(event.data);
        this.processNext(event, itemCtx);
    };
    Properties.prototype.setUser = function (user) {
        this._user = user;
    };
    Properties.prototype.setProperty = function (name, value) {
        //1DS SDK transport will validate name and value so not duplicating it here.     
        this._props[name] = value;
    };
    Properties.prototype._addPropsIfNotAlreadyAdded = function (data) {
        var _this = this;
        Utils.arrForEach(Utils.objKeys(this._props), function (key) {
            if (!Utils.isValueAssigned(data[key])) {
                data[key] = _this._props[key];
            }
        });
    };
    Properties.prototype._removeEmptyKeys = function (input) {
        var _this = this;
        Utils.arrForEach(Utils.objKeys(input), function (key) {
            if (input[key] && Utils.isObject(input[key]) && !CoreUtils.isDate(input[key])) {
                if (Utils.objKeys(input[key]).length === 0) {
                    delete input[key];
                }
                else {
                    _this._removeEmptyKeys(input[key]);
                }
            }
            else if (!Utils.isValueAssigned(input[key])) {
                delete input[key];
            }
        });
    };
    return Properties;
}(BaseTelemetryPlugin));
export default Properties;
//# sourceMappingURL=Properties.js.map